import * as React from 'react';
import classnames from 'classnames';
import isFunction from 'lodash/isFunction';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './banner.scss';

type Props = {
  children: React.ReactNode,
  background: 'on-white' | 'on-grey',
  borderRadius?: number,
  withBoxShadow?: boolean,
  withBorder?: boolean,
  onClose?: () => void
};

const Banner = ({
  children,
  background = 'on-white',
  borderRadius,
  withBoxShadow,
  withBorder,
  onClose
}: Props) => {
  const renderClose = (): React.ReactNode => (
    <div className="banner__close">
      <SVGDynamicIcon
        name="cross-custom-fg"
        width={12}
        height={12}
        customColor="grey"
        onClick={onClose}
      />
    </div>
  );

  const styles = {} as React.CSSProperties;

  if (borderRadius) {
    styles.borderRadius = borderRadius;
  }

  const containerClasses = classnames('banner', {
    'banner--box-shadow': Boolean(withBoxShadow),
    'banner--border': Boolean(withBorder),
    [`banner--${background}`]: Boolean(background)
  });

  return (
    <div
      className={containerClasses}
      style={{ ...styles }}
    >
      {isFunction(onClose) && renderClose()}
      <div className="banner__children">
        {children}
      </div>
    </div>
  );
};

export default Banner;
